export default "/images/aros.png?673406ca9a870d8b5582e7c19daf7a83";